// extracted by mini-css-extract-plugin
export default {"settings":"styles__settings___vOBoD","settingsButton":"styles__settingsButton___JCgOY link__button___3l2Cw base__button___zT0JW","settingsLabel":"styles__settingsLabel___5Rsvf"};